import { CategorizationLayout } from '../../../components/Categorization';

export function Regions() {
  return <CategorizationLayout type="region" translationContext="female" omitFields={['searchKeywords']} />;
}
